/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiimagepromptplaceholder3Inputs */

const en_aiimagepromptplaceholder3 = /** @type {(inputs: Aiimagepromptplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. A cozy cafe table with coffee and pastries`)
};

const de_aiimagepromptplaceholder3 = /** @type {(inputs: Aiimagepromptplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Ein gemütlicher Cafétisch mit Kaffee und Gebäck`)
};

/**
* | output |
* | --- |
* | "e.g. A cozy cafe table with coffee and pastries" |
*
* @param {Aiimagepromptplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiimagepromptplaceholder3 = /** @type {((inputs?: Aiimagepromptplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiimagepromptplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiimagepromptplaceholder3(inputs)
	return de_aiimagepromptplaceholder3(inputs)
});
export { aiimagepromptplaceholder3 as "aiImagePromptPlaceholder" }